import { render } from "./PatientLogin.vue?vue&type=template&id=8df73ebe&scoped=true"
import script from "./PatientLogin.vue?vue&type=script&lang=js"
export * from "./PatientLogin.vue?vue&type=script&lang=js"

import "./PatientLogin.vue?vue&type=style&index=0&id=8df73ebe&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8df73ebe"]])

export default __exports__